export const defaultBackendUrl = '/beholder';

export enum Severity {
  Warning = 'Warning',
  Error = 'Error',
  Info = 'Info',
  Log = 'Log',
  Debug = 'Debug',
}
